import React from 'react'
import { connect } from 'react-redux'
import { compose, lifecycle, withState } from 'recompose'
import { Icon, Button } from 'semantic-ui-react'
import ReactTable from 'react-table'

import { Cont } from './styled'
import { StdForm } from 'components'
import { fetchRoles, fetchPermissions } from 'ducks/roleMan'
import { columns } from '../../AttributeData'
import { btnGray } from 'variables/styles'

import FormRoleModal from '../../FormRoleModal'
import FormPermissionRoleModal from '../../FormPermissionRoleModal'

let refTable = React.createRef()

const RoleSection = props => {
  const {
    roles,
    showModal,
    setShowModal,
    modalData,
    setModalData,
    modalTitle,
    setModalTitle,
    modalIsCreate,
    setModalIsCreate,
    roleId,
    setRoleId,
    defaultPage,
    setDefaultPage,
  } = props
  const defaultExpanded = props.roles.map((item,i)=> {
    return false
  })
  return (
    <Cont>
      <StdForm
        fitContent={false}
        title={
          <div>
            Role
            <Icon
              link
              circular
              inverted
              color="teal"
              name="add"
              size="small"
              style={{ marginLeft: '1rem' }}
              onClick={() => showRoleModal(true, null)}
            />
          </div>
        }
        style={{ width: '80vw' }}
        enableCollapse
      >
        <ReactTable
          ref={r => (refTable = r)}
          data={roles && roles}
          defaultExpanded={{defaultExpanded}}
          collapseOnDataChange={false}
          columns={columns.tRole}
          defaultPageSize={10}
          previousText="previous"
          nextText="next"
          className="-striped -highlight"
          onPageChange={state => {
            props.setDefaultPage(state)
          }}
          page={defaultPage}
          SubComponent={row => {
            return (
              <div style={{ padding: '1rem', width: '70vw' }}>
                <Button
                  onClick={() =>
                    showPermissionRoleModal(true, null, row.original.id)
                  }
                  positive
                  labelPosition="right"
                  icon="add"
                  content="Add"
                  style={{ fontSize: '11px' }}
                />
                <div style={{ height: '1rem' }} />
                <ReactTable
                  data={row.original.permission}
                  columns={columns.tPermissionRole}
                  defaultPageSize={5}
                  getTdProps={(state, rowInfo, column, instance) => {
                    if (column.Header) {
                      return {
                        onClick: (e, handleOriginal) => {
                          if (rowInfo && column.Header) {
                            showPermissionRoleModal(false, rowInfo.original, 0)
                          }
                        },
                      }
                    } else {
                      return {}
                    }
                  }}
                />
              </div>
            )
          }}
          getTdProps={(state, rowInfo, column, instance) => {
            return {
              onClick: (e, handleOriginal) => {
                if (!column.Header) {
                  state.expanded[rowInfo.index] = !state.expanded[rowInfo.index]
                } else if (column.Header) {
                  if (rowInfo && column.Header) {
                    showRoleModal(false, rowInfo.original)
                  }
                }
                if (handleOriginal) {
                  handleOriginal()
                }
              },
              style: {
                background: rowInfo
                  ? state.expanded[rowInfo.index]
                    ? btnGray
                    : 'initial'
                  : null,
                color: rowInfo
                  ? state.expanded[rowInfo.index]
                    ? '#fff'
                    : 'initial'
                  : null,
              },
            }
          }}
        />
      </StdForm>
      {showModal.role ? (
        <FormRoleModal
          title={modalTitle}
          data={modalData}
          isCreate={modalIsCreate}
          show={showModal.role}
          tablePageSize={refTable ? refTable.state.pageSize : 5}
          setCurrentPage={props.setDefaultPage}
          changeShow={() =>
            setShowModal({ ...showModal, role: !showModal.role })
          }
        />
      ) : null}
      {showModal.permissionRole ? (
        <FormPermissionRoleModal
          title={modalTitle}
          roleId={roleId}
          data={modalData}
          isCreate={modalIsCreate}
          show={showModal.permissionRole}
          changeShow={() =>
            setShowModal({
              ...showModal,
              permissionRole: !showModal.permissionRole,
            })
          }
        />
      ) : null}
    </Cont>
  )

  function showRoleModal(isCreate, data) {
    if (isCreate) {
      setModalIsCreate(true)
      setModalTitle('Create Role')
      setModalData(null)
    } else {
      setModalIsCreate(false)
      setModalTitle('Update Role')
      setModalData(data)
    }
    setShowModal({ ...showModal, role: true })
  }

  function showPermissionRoleModal(isCreate, data, roleId) {
    setRoleId(roleId)
    if (isCreate) {
      setModalIsCreate(true)
      setModalTitle('Add Permission To Role')
      setModalData(null)
    } else {
      setModalIsCreate(false)
      setModalTitle('Update Permission Of Role')
      setModalData(data)
    }
    setShowModal({ ...showModal, permissionRole: true })
  }
}

const mapStateToProps = state => ({
  roles: state.roleMan.roles,
  permissions: state.roleMan.permissions,
})

const mapDispatchToProps = {
  fetchRoles,
  fetchPermissions,
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('showModal', 'setShowModal', {
    role: false,
    permission: false,
    permissionRole: false,
  }),
  withState('modalIsCreate', 'setModalIsCreate', false),
  withState('modalData', 'setModalData', null),
  withState('modalTitle', 'setModalTitle', ''),
  withState('roleId', 'setRoleId', 0),
  withState('defaultPage', 'setDefaultPage', 0),
  lifecycle({
    componentDidMount() {
      this.props.fetchRoles()
      this.props.fetchPermissions()
    },
    componentWillReceiveProps(nextProp) {},
  })
)

export default enhance(RoleSection)
